import React, { useContext, useCallback } from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';

import { ConfigContext } from '../config';

export const CheckboxField = ({ id, label, ...props }) => {
  const { useConfig, setConfig } = useContext(ConfigContext);
  const value = useConfig(id);

  const handleChange = useCallback(
    (event) => {
      setConfig(id, event.target.checked);
    },
    [setConfig, id],
  );

  return (
    <FormControlLabel
      control={<Switch size="small" {...props} />}
      checked={value}
      onChange={handleChange}
      label={label}
      style={{ marginBottom: '0.25rem', marginLeft: '-0.45rem' }}
    />
  );
};

export default CheckboxField;
